import React from 'react';
import { PercentAmount, decimalsToWei } from '@akropolis-web/primitives';

import { MarketBadDebtRatingInfo } from 'domain/types';
import { getAmount } from 'domain/utils';

import { MarketName } from '../MarketName';
import { FormattedAmount } from '../FormattedAmount';

const SIGNIFICANT_MAX_DEBT_VALUE = getAmount(30000, '$').mul(decimalsToWei(18));
const SIGNIFICANT_DEBT_SHARE_VALUE = new PercentAmount(0.2);

export function MarketBadDebtTranscription({ rating, transcription }: MarketBadDebtRatingInfo) {
  const { maxDebt, debtShare } = rating.payload;
  const { marketName } = transcription;

  if (maxDebt.gt(SIGNIFICANT_MAX_DEBT_VALUE) && debtShare.gt(SIGNIFICANT_DEBT_SHARE_VALUE)) {
    return (
      <span>
        The largest undercollateralized debt position is{' '}
        <FormattedAmount sum={maxDebt} precision={0} />, and cumulative debts take up to{' '}
        <FormattedAmount sum={debtShare} precision={2} symbolSize="inherit" /> of the TVL
      </span>
    );
  }

  if (maxDebt.gt(SIGNIFICANT_MAX_DEBT_VALUE)) {
    return (
      <span>
        {marketName} has undercollateralized debt, with the largest position amounting to{' '}
        <FormattedAmount sum={maxDebt} precision={0} />
      </span>
    );
  }

  if (debtShare.gt(SIGNIFICANT_DEBT_SHARE_VALUE)) {
    return (
      <span>
        Cumulative undercollateralized debts take up to{' '}
        <FormattedAmount sum={debtShare} precision={2} symbolSize="inherit" /> of TVL
      </span>
    );
  }

  return (
    <>
      <MarketName marketName={marketName} /> <span>has no to little undercollateralized debt</span>
    </>
  );
}
